module.exports = __webpack_public_path__ + "media/images/home/step_template_3rd-5026a3f23385bf157b314854cb720565.svg";